/* istanbul ignore file */
import { stringify } from "query-string";

import { mainApi } from "config/api";
import { getClientFor } from "infrastructure/http";

import { ISecurityRolesByEnterpriseRequest, ISecurityRolesByTenantRequest, ISecurityRolesResponse } from "./SecurityRole.api.types";

export const getSecurityRolesByEnterprise = async (request: ISecurityRolesByEnterpriseRequest): Promise<ISecurityRolesResponse[]> => {
  return (
    await getClientFor(mainApi.name).get(`/security-roles/enterprises/${request.enterpriseId}`, {
      params: {
        filter: request.filter
      },
      paramsSerializer: p => {
        return stringify(p);
      }
    })
  ).data;
};

export const getSecurityRolesByTenant = async (request: ISecurityRolesByTenantRequest): Promise<ISecurityRolesResponse[]> => {
  return (
    await getClientFor(mainApi.name).get(`/security-roles/tenants/${request.tenantId}`, {
      params: {
        filter: request.filter
      },
      paramsSerializer: p => {
        return stringify(p);
      }
    })
  ).data;
};
